import type { CustomerSummary } from './models'

/** Normalize API payload rows into {@link CustomerSummary}. Invalid rows are skipped. */
export function normalizeCustomerSummaries(raw: unknown): CustomerSummary[] {
  if (!Array.isArray(raw)) return []
  const out: CustomerSummary[] = []
  for (const row of raw) {
    const n = normalizeCustomerSummary(row)
    if (n) out.push(n)
  }
  return out
}

export function normalizeCustomerSummary(raw: unknown): CustomerSummary | null {
  if (!raw || typeof raw !== 'object') return null
  const r = raw as Record<string, unknown>
  const name = typeof r.customerName === 'string' ? r.customerName.trim() : ''
  if (!name) return null
  const email =
    typeof r.customerEmail === 'string' && r.customerEmail.trim().length > 0 ? r.customerEmail.trim() : null
  const phone =
    typeof r.customerPhone === 'string' && r.customerPhone.trim().length > 0 ? r.customerPhone.trim() : null
  const lastTradeAt =
    typeof r.lastTradeAt === 'string' && r.lastTradeAt.length > 0 ? r.lastTradeAt : new Date(0).toISOString()
  const tradeCount = typeof r.tradeCount === 'number' && Number.isFinite(r.tradeCount) ? Math.max(0, r.tradeCount) : 0
  return {
    customerName: name,
    customerEmail: email,
    customerPhone: phone,
    lastTradeAt,
    tradeCount,
  }
}
